import { supabase } from '../supabaseClient';

export const PortalAgreementsService = {
  async listAgreements(clientId) {
    if (!clientId) return { data: [], error: new Error('Missing client id') };
    try {
      const { data, error } = await supabase
        .from('agreements')
        .select(`
          id,
          title,
          status,
          sent_at,
          signed_at,
          due_date,
          total_amount,
          agreement_number
        `)
        .eq('client_id', clientId)
        .order('sent_at', { ascending: false });
      if (error) throw error;
      return { data: data || [], error: null };
    } catch (error) {
      console.error('[PortalAgreementsService] listAgreements failed', error);
      return { data: [], error };
    }
  },

  async getAgreementItems(agreementId) {
    if (!agreementId) return { data: [], error: new Error('Missing agreement id') };
    try {
      const { data, error } = await supabase
        .from('agreement_items')
        .select('id,title,description,quantity,unit_price,total_price,sort_order')
        .eq('agreement_id', agreementId)
        .order('sort_order', { ascending: true });
      if (error) throw error;
      return { data: data || [], error: null };
    } catch (error) {
      console.error('[PortalAgreementsService] getAgreementItems failed', error);
      return { data: [], error };
    }
  },

  async generateAcceptanceToken(agreementId, recipientEmail) {
    if (!agreementId) return { data: null, error: new Error('Missing agreement id') };
    try {
      const { data, error } = await supabase.rpc('agreement_generate_acceptance_token', {
        p_agreement_id: agreementId,
        p_recipient_email: recipientEmail || null
      });
      if (error) throw error;
      return { data, error: null };
    } catch (error) {
      console.error('[PortalAgreementsService] generateAcceptanceToken failed', error);
      return { data: null, error };
    }
  },

  async getActionRequiredCount(clientId) {
    if (!clientId) return { data: 0, error: null };
    try {
      const { count, error } = await supabase
        .from('agreements')
        .select('id', { count: 'exact', head: true })
        .eq('client_id', clientId)
        .in('status', ['pending', 'sent', 'draft']);
      if (error) throw error;
      return { data: count || 0, error: null };
    } catch (error) {
      console.error('[PortalAgreementsService] getActionRequiredCount failed', error);
      return { data: 0, error };
    }
  }
};


